import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {GlobalSearchCategory} from '@global-search/data-access';
import {IconComponent} from '@shared/icon';
import {GlobalSearchUiStore} from '../../store/global-search-ui.store';
import {TranslateModule, TranslateService} from '@ngx-translate/core';

// Assuming IconComponent might be used for category icons later

@Component({
	selector: 'dc-tab-navigation',
	imports: [IconComponent, TranslateModule],
	templateUrl: './tab-navigation.component.html',
	styleUrl: './tab-navigation.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabNavigationComponent {
	// --- Inputs ---
	readonly categories = input.required<GlobalSearchCategory[]>();
	readonly activeCategory = input<GlobalSearchCategory | null>(null);
	// --- Outputs ---
	readonly categorySelected = output<GlobalSearchCategory>();
	protected readonly uiStore = inject(GlobalSearchUiStore);
	protected readonly translateService = inject(TranslateService);

	// --- Component State Signals ---
	// No internal state signals needed for this component currently

	// --- Private Properties ---
	// Map category enum to display properties (label, icon)
	// This makes the template cleaner
	protected readonly categoryDisplayMap: Record<GlobalSearchCategory, {label: string; icon: string}> = {
		[GlobalSearchCategory.CYCLE]: {
			label: 'components.globalSearch.documents',
			icon: 'fas fa-file-alt',
		}, // Using translation key
		[GlobalSearchCategory.USER]: {
			label: 'components.globalSearch.users',
			icon: 'fas fa-users',
		},
		[GlobalSearchCategory.USER_GROUP]: {
			label: 'components.globalSearch.groups',
			icon: 'fas fa-object-group',
		},
		// Add other categories if they exist
	};

	// --- Constructor ---
	constructor() {} // Usually empty

	// --- Lifecycle Hooks ---
	// ngOnInit(): void {} // Not needed currently

	// --- Methods ---

	/**
	 * Handles the click event on a category tab button.
	 * Emits the selected category via the output.
	 * @param category The category that was clicked.
	 */
	protected onSelectCategory(category: GlobalSearchCategory): void {
		// Prevent emitting if the clicked category is already active (optional optimization)
		if (category !== this.activeCategory()) {
			this.categorySelected.emit(category);
		}
	}
}
